import React, { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { Container } from "@mui/system";
import { useNavigate } from "react-router-dom";
import FormularyIcon from "../imagenes/formlary_icon.png";
import ReporteIcon from "../imagenes/reporte_icon.png";
import useUser from "../hooks/useUser";

export default function MenuPrincipal() {

  const navigate = useNavigate();

  const user = useUser();

  const verificarUsuario = () => {

    if (!user.codigo_usuario) {
      alert("Debe autenticarse, Redirigiendo...");
      navigate("/login"); // ✅ esto sí funciona
    }

  };

  useEffect(() => {

    verificarUsuario();

  }, []);

  const cerrarSesion = () => {

    sessionStorage.clear();
    sessionStorage.setItem("token", null);
    user.codigo_usuario = null
    navigate("/login");

  };

  return (
    <Container fixed>
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          alignContent: "flex-center",
          alignItems: "flex-center",
          bgcolor: "white",
          padding: "1%",
        }}
      >
        <h1>Menu General</h1>
        <Button
          variant="contained"
          color="success"
          style={{ height: 30, marginTop: 40, marginLeft: 3 }}
          onClick={() => {
            cerrarSesion();
          }}
        >
          Cerrar Sesión
        </Button>
      </Box>
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          flexWrap: "wrap",
          justifyContent: "center",
          alignContent: "space-between",
          alignItems: "flex-start",
          bgcolor: "green",
          padding: "10%",
          borderRadius: 10,
        }}
      >
        <Card sx={{ minWidth: 20, margin: 5, borderRadius: 10 }}>
          <CardContent>
            <Typography variant="h5" component="div">
              Formularios
            </Typography>
          </CardContent>
          <img
            src={FormularyIcon}
            height="120"
            width="150"
            alt="formulario icon"
            style={{
              marginTop: "20px",
              marginBottom: "10px",
              marginLeft: "30px",
              marginRight: "20px",
              display: "block",
            }}
          ></img>
          <CardActions>
            <Button size="small" onClick={() => navigate("/menu-categorias")}>
              Ver
            </Button>
          </CardActions>
        </Card>
        <Card sx={{ minWidth: 20, margin: 5, borderRadius: 10 }}>
          <CardContent>
            <Typography variant="h5" component="div">
              Reportes
            </Typography>
          </CardContent>
          <img
            src={ReporteIcon}
            height="120"
            width="150"
            alt="formulario icon"
            style={{
              marginTop: "20px",
              marginBottom: "10px",
              marginLeft: "30px",
              marginRight: "20px",
              display: "block",
            }}
          ></img>
          <CardActions>
            <Button size="small" onClick={() => navigate("/menu-categorias-reportes")}>
              Ver
            </Button>
          </CardActions>
        </Card>
      </Box>
    </Container>
  );
}
